export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idcaja: '',
        idcategoria: '',
        descripcion_corta: '',
        descripcion_larga: '',
        currency_type: '',
        retirable: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}